export default API => ({
    // 是否实名
    getUrlPcAndH5 () {
      return API({ url: `/saas/v1/jiaoDa/domainName/getList`, method:'get' })
    },
  })
  